var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.pagination.lastPage > 1)?_c('v-pagination',{attrs:{"length":_vm.pagination.lastPage},model:{value:(_vm.pagination.page),callback:function ($$v) {_vm.$set(_vm.pagination, "page", $$v)},expression:"pagination.page"}}):_c('div')}
var staticRenderFns = []

export { render, staticRenderFns }